import { type ObjectValuesUnionType } from '../utils/typing';

import type { BetBuilderActionType } from './actions/betbuilder';
import { BetTypes } from './bet';

export type BetBuilderSelectionItem = {
  betId: number;
  matchId: number;
  outcomeId: number | null;
  outcomeIds: Array<number> | null;
  oddId?: number;
};

export const BetBuilderItemStatuses = Object.freeze({
  OK: 'OK',
  INVALID: 'INVALID',
});

export type BetBuilderItemStatus = ObjectValuesUnionType<typeof BetBuilderItemStatuses>;

export const BetBuilderSelectionStatuses = Object.freeze({
  OK: 'OK',
  EMPTY: 'EMPTY',
  LOADING: 'LOADING',
  INVALID: 'INVALID',
});

export type BetBuilderSelectionStatus = ObjectValuesUnionType<typeof BetBuilderSelectionStatuses>;

export const BetBuilderStatuses = Object.freeze({
  OK: 'OK',
  INIT: 'INIT',
  LOADING: 'LOADING',
  INVALID: 'INVALID',
});

export type BetBuilderStatus = ObjectValuesUnionType<typeof BetBuilderStatuses>;

export type BetBuilderAction = {
  type: BetBuilderActionType;
  payload: unknown;
};

export const BetbuilderErrorCodes = Object.freeze({
  UNAVAILABLE: 400,
  INCOHERENT_SELECTIONS: 401,
  TOO_MANY_SELECTIONS: 402,
  ONE_OR_MORE_SELECTION_UNAVAILABLE: 403,
  MATCH_UNBALANCED: 404,
  TOO_MANY_GOALS: 405,
  TOO_MANY__MULTICHANCE: 406,
  UNAVAILABLE_ODD: 500,
});

export type BetbuilderErrorCode = ObjectValuesUnionType<typeof BetbuilderErrorCodes>;

export const BetBuilderMoreOptionsBetTypeIds = [
  BetTypes.SOCCER_MULTI_SCORERS_PREMATCH,
  BetTypes.SOCCER_DOUBLE_CHANCE_SCORER,
  BetTypes.SOCCER_TRIPLE_CHANCE_SCORER,
  BetTypes.SOCCER_EXACT_SCORE_MULTICHANCE,
];

export const BetBuilderMoreOptionsRedirections = Object.freeze({
  [BetTypes.SOCCER_MULTI_SCORERS_PREMATCH]: {
    betTypeId: BetTypes.SOCCER_ANYTIME_SCORER,
    hasMultichoiceVariant: false,
  },
  [BetTypes.SOCCER_DOUBLE_CHANCE_SCORER]: {
    betTypeId: BetTypes.SOCCER_ANYTIME_SCORER,
    hasMultichoiceVariant: true,
  },
  [BetTypes.SOCCER_TRIPLE_CHANCE_SCORER]: {
    betTypeId: BetTypes.SOCCER_ANYTIME_SCORER,
    hasMultichoiceVariant: true,
  },
  [BetTypes.SOCCER_EXACT_SCORE_MULTICHANCE]: {
    betTypeId: BetTypes.SOCCER_EXACT_SCORE,
    hasMultichoiceVariant: true,
  },
});

export type BetBuilderMoreOptionsRedirection = ObjectValuesUnionType<typeof BetBuilderMoreOptionsRedirections>;
